export default "__VITE_ASSET__547f3eb6__"